import { BookOpenText } from "lucide-react";

import normalizeResolution from "@/hooks/normalizeResolution";

export default function PreRoundTopicContext({ isRoundStarted, resolution }) {
  const normalizedResolution = normalizeResolution(resolution);
  if (!normalizedResolution || isRoundStarted) return null;

  return (
    <section
      className="topic-guidance section-reveal"
      data-testid="pre-round-topic-context"
    >
      <div className="guidance-summary">
        <p className="eyebrow">
          <BookOpenText size={14} /> Pre-round topic context
        </p>
        <h2>What this topic is about</h2>
        <p data-testid="pre-round-topic-context-text">
          This round examines the claim in the resolution: “{normalizedResolution}”.
          Before the timer starts, use the exact wording to identify the question the
          teams will address. This static context does not suggest arguments or research.
        </p>
      </div>
    </section>
  );
}